import React, {useEffect, useState} from 'react'

const SingleDay = (props) => {

    const [ historyList, setHistoryList ] = useState([])

    useEffect( () => {
        let managerObj = {}
        if (props.managerList) {
            props.managerList.forEach( ele => {
                managerObj[ele.user_id] = ele.name
            })
        }
        if (props.dayData) {
            if (props.dayData.manager_movement) {
                let localHistoryArray = []
                props.dayData.manager_movement.forEach( (ele, eleid) => {
                    let localSplitArray = ele.split('&')
                    let manId = localSplitArray.length > 1 ? localSplitArray[0] : null
                    let editDate = localSplitArray.length > 1 ? localSplitArray[1] : null
                    let editOrCreate = localSplitArray.length > 2 ? localSplitArray[2] : null
                    localHistoryArray.push(
                        <div className='singleDayArrayObj'>
                            <ul>
                                <li>{manId ? managerObj[manId] : 'no name found'}</li>
                                <li>{editDate.length > 10 ? `edited on ${new Date(editDate).toLocaleDateString('en-gb')} at ${new Date(editDate).getHours()}:${new Date(editDate).getMinutes()}:${new Date(editDate).getSeconds()}`: `created on ${new Date(editOrCreate).toLocaleDateString('en-gb')} at ${new Date(editOrCreate).getHours()}:${new Date(editOrCreate).getMinutes()}:${new Date(editOrCreate).getSeconds()}`}</li>
                                <li>{editOrCreate.length > 10 ? `Initial location: ${editDate}` : 'edited in the daily service'}</li>
                            </ul>
                        </div>
                    )
                })
                setHistoryList(localHistoryArray)
            }
        }
    }, [props])

    return (
        <div className='singleDayReports'>
            <h1>{props.dayData.date ? props.dayData.date : 'No Date'}</h1>
            <h3>Driver Name: {props.driverData ? props.driverData.name : 'no driver data'}</h3>
            <div className='singleDayArrayObj'>
                {historyList}
            </div>
            <button onClick={props.returnFromScreen}>Return</button>
        </div>
    )
}

export default SingleDay